import React from 'react';

type ErrorStateProps = {
  isMenuExpanded: boolean;
};

export const ErrorState = ({ isMenuExpanded }: ErrorStateProps): React.ReactElement => (
  <div
    style={{
      display: isMenuExpanded ? 'flex' : 'none',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: '#FFFFFF',
      borderRight: '1px solid #EDEDED',
      height: '100vh',
      width: '272px',
      padding: '24px',
      gap: '16px',
      fontFamily: `ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif`,
    }}
  >
    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', textAlign: 'center' }}>
      <p
        style={{
          margin: 0,
          color: '#212121',
          fontSize: '16px',
          fontWeight: 700,
          lineHeight: '20px',
        }}
      >
        Menu is unavailable
      </p>
      <p
        style={{
          margin: 0,
          color: '#737373',
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '18px',
        }}
      >
        We apologise for the inconvenience. Please refresh the page, or contact your admin if the
        error continues.
      </p>
    </div>
    <button
      type="button"
      onClick={(): void => window.location.reload()}
      style={{
        padding: '6px 12px',
        backgroundColor: '#ffffff',
        border: '1px solid #E4E4E4',
        borderRadius: '4px',
        cursor: 'pointer',
        color: '#212121',
        fontSize: '14px',
        fontWeight: 500,
      }}
    >
      Refresh
    </button>
  </div>
);
